module.exports = __webpack_public_path__ + "img/INTERIOR-FRONX-BOOSTERGREEN-6.a38b0bf7.jpg";